import _mapBoosters from './boosters';
import _mapRewards from './rewards';

export const mapBoosters = _mapBoosters;
export const mapRewards = _mapRewards;
